import { LayoutDashboard, Shield, Settings2, Sparkles, type LucideIcon } from 'lucide-react';

export const STAFF_EMAIL_SUFFIX = '@tyaus.com';

export function isStaffEmail(email: string): boolean {
  return email.toLowerCase().endsWith(STAFF_EMAIL_SUFFIX);
}

export interface Platform {
  label: string;
  description: string;
  url: string;
  icon: LucideIcon;
  staffOnly: boolean;
}

export const PLATFORMS: Platform[] = [
  {
    label: 'Client Dashboard',
    description: 'Manage your GPU workspaces and billing',
    url: 'https://client.tyaus.com',
    icon: LayoutDashboard,
    staffOnly: false,
  },
  {
    label: 'Insight Dashboard',
    description: 'RAG knowledge search and document Q&A',
    url: 'https://insight.tyaus.com',
    icon: Sparkles,
    staffOnly: false,
  },
  {
    label: 'Admin Dashboard',
    description: 'Manage users, nodes, and platform settings',
    url: 'https://admin.tyaus.com',
    icon: Shield,
    staffOnly: true,
  },
  {
    label: 'Manage Dashboard',
    description: 'Website management — cookies, visitors, and contacts',
    url: 'https://manage.tyaus.com',
    icon: Settings2,
    staffOnly: true,
  },
];

export function platformsForUser(email: string | undefined): Platform[] {
  if (!email || isStaffEmail(email)) {
    return PLATFORMS;
  }
  return PLATFORMS.filter((platform) => !platform.staffOnly);
}
